import { Map, List, fromJS } from 'immutable'

const types = ['NOTE_LOADING', 'NOTE_SUCCESS', 'NOTE_ERROR', 'NOTE_CHANGE', 'NOTE_OPEN', 'NOTE_EDIT', 'NOTE_CLOSE']

export function notes(state = Map(), action) {
  if (!types.includes(action.type)) return state

  let { entity, entity_id, note, type, noteType, loading = false, message, content } = action
  let id = `${entity}.${entity_id}.${noteType}`

  if (type === 'NOTE_LOADING') return state.setIn([id, 'loading'], loading)

  if (type === 'NOTE_SUCCESS')
    return state
      .setIn([id, 'loading'], false)
      .setIn([id, 'initialLoad'], true)
      .setIn([id, 'open'], false)
      .setIn([id, 'editing'], false)
      .setIn([id, 'note'], note ? fromJS(note) : Map())

  if (type === 'NOTE_ERROR')
    return state.setIn([id, 'loading'], false).setIn([id, 'initialLoad'], true).setIn([id, 'error'], message)

  if (type === 'NOTE_CHANGE') return state.setIn([id, 'note', 'content'], content)

  if (type === 'NOTE_OPEN') return state.setIn([id, 'open'], true)

  if (type === 'NOTE_EDIT') return state.setIn([id, 'editing'], true).setIn([id, 'open'], true)

  if (type === 'NOTE_CLOSE') return state.setIn([id, 'editing'], false).setIn([id, 'open'], false)

  return state
}
